const { REACT_APP_API } = process.env

export const getToken = async () => {
    const response = await fetch(`${REACT_APP_API}/get/credentials`);
    return await response.json();
}
